var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76.2712,
    height: 76.2712,
    rx: 16,
    fill: "url(#paint0_radial_186_3473)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.7161 13.2646L56.9553 19.3158L63.0065 21.555L56.9553 23.7941L54.7161 29.8453L52.477 23.7941L46.4258 21.555L52.477 19.3158L54.7161 13.2646Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8965,
    y: 33.1611,
    width: 9.94842,
    height: 9.94842,
    rx: 1.52542,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.4258,
    y: 33.1611,
    width: 9.94842,
    height: 9.94842,
    rx: 1.52542,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.4258,
    y: 46.4258,
    width: 9.94842,
    height: 9.94842,
    rx: 1.52542,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8965,
    y: 46.4258,
    width: 9.94842,
    height: 9.94842,
    rx: 1.52542,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8965,
    y: 19.8965,
    width: 9.94842,
    height: 9.94842,
    rx: 1.52542,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33.1621,
    y: 19.8965,
    width: 9.94842,
    height: 6.63228,
    rx: 1.52542,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_186_3473",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.2712 -4.54612e-06) rotate(135) scale(107.864)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2948FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantTeacher);
export default __webpack_public_path__ + "static/media/assistant-teacher.046f1423.svg";
export { ForwardRef as ReactComponent };